(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var inView = require('../plugins/in-view');

(function($) {
  if (typeof window.Fund == 'undefined') window.Fund = {};

  Fund = {
    init: function() {
      if (!$('.fund-navigation').length) return;

      inView.threshold(1);

      // Navigation
      this.stickyNav()
      this.checkArrowNavigation()
      this.navClickEvents()
      this.arrowNavigation()

      window.addEventListener('resize', e => {
        this.checkArrowNavigation()
      })

      window.addEventListener('scroll', e => {
        this.scrollWatch()
        this.stickyNav()
      })

      $('.fund-navigation-menu__track')[0].addEventListener('scroll', e => {
        this.checkArrowNavigationStates()
      })

      // Slider
      this.sliderModule()
    },
    sliderModule: function() {
      let $sliders = $('.slider-container__content');

      $sliders.each(function() {
        let currentSlide = 0;
        let $slides = $(this).find('.slider-container__slide')
        if ($slides.length > 1) {
          $(this).find('.slider-container__navigation').removeClass('disabled');

          $(this).find('.slider-container__navigation').on('click', function() {
            $slides.removeClass('is-active')
            if ($(this).hasClass('slider-container__navigation--prev')) {
              if (currentSlide === 0) currentSlide = $slides.length - 1
              else currentSlide--
              $slides.eq(currentSlide).addClass('is-active')
            } else {
              if (currentSlide === $slides.length - 1) currentSlide = 0
              else currentSlide++
              $slides.eq(currentSlide).addClass('is-active')
            }
          })
        }
      })
    },
    stickyNav: function() {
      let bb = document.querySelector('.fund-navigation--fake').getBoundingClientRect()
      let $navReal = $('.fund-navigation--real')
      let $navFake = $('.fund-navigation--fake')
      if (bb.top <= 0) {
        $navReal.addClass('sticky');
        $navFake.addClass('sticky-active');
      } else {
        $navReal.removeClass('sticky');
        $navFake.removeClass('sticky-active');
      }
    },
    arrowNavigation: function() {
      let $navPrev = $('.fund-navigation-arrow--prev')
      let $navNext = $('.fund-navigation-arrow--next')
      let $navTrack = $('.fund-navigation--real .fund-navigation-menu__track')
      let $navItems = $('.fund-navigation--real .fund-navigation-menu__items')

      let scrollPercentage = function() {
        let scrollRatio = $navTrack.width() / $navItems.width()
        return $navTrack.width() * scrollRatio
      }

      $navPrev.on('click', function() {
        $navTrack.animate({
          scrollLeft: $navTrack.scrollLeft() - scrollPercentage()
        }, 500);
      })

      $navNext.on('click', function() {
        $navTrack.animate({
          scrollLeft: $navTrack.scrollLeft() + scrollPercentage()
        }, 500);
      })
    },
    checkArrowNavigationStates: function(el) {
      let $navTrack = $('.fund-navigation--real .fund-navigation-menu__track')
      let $navPrev = $('.fund-navigation-arrow--prev')
      let $navNext = $('.fund-navigation-arrow--next')

      // prev
      if ($navTrack.scrollLeft() === 0) $navPrev.addClass('disabled')
      else $navPrev.removeClass('disabled')

      // next
      if ($navTrack[0].scrollWidth - $navTrack.scrollLeft() - $navTrack.width() <= 0) $navNext.addClass('disabled')
      else $navNext.removeClass('disabled')
    },
    checkArrowNavigation: function() {
      var $track = $('.fund-navigation--real .fund-navigation-menu__track')
      var $items = $('.fund-navigation--real .fund-navigation-menu__items')
      let $navReal = $('.fund-navigation--real')

      if ($items.width() > $track.width()) $navReal.addClass('arrows-active')
      else $navReal.removeClass('arrows-active')
    },
    scrollWatch: function() {
      var $anchorPoints = $('.fund-anchor-point')
      let isTop = true
      let navHeight = $(window).width() <= 1024 ? 59 : 69
      var currentNav = null

      $anchorPoints.each(function() {
        let bb = $(this)[0].getBoundingClientRect()
        if (bb.top - navHeight <= 0) {
          $('.fund-navigation--real .fund-navigation-menu__item a').removeClass('active')
          $('.fund-navigation--real .fund-navigation-menu__item a[data-link="' + $(this).data('anchor-point') + '"]').addClass('active')
          currentNav =    $(this).data('anchor-point')
          isTop = false
        }
      })


      if (!isTop) {
        let $currentNav = $('.fund-navigation--real .fund-navigation-menu__item a[data-link="' + currentNav + '"]')
        if (!inView.is($currentNav[0])) {
          let currentOffsetLeft =  $currentNav.parent()[0].offsetLeft - $('.fund-navigation--real .fund-navigation-menu__track')[0].offsetLeft
          $('.fund-navigation--real .fund-navigation-menu__track').scrollLeft(currentOffsetLeft)
        }
      }

      if (isTop) {
        $('.fund-navigation--real .fund-navigation-menu__item a').removeClass('active')
      }
    },
    navClickEvents: function() {
      $('.fund-navigation-menu__item a').on('click', function(e) {
        let navHeight = $(window).width() <= 1024 ? 59 : 69
        $("html, body").animate({
          scrollTop: $('.fund-anchor-point[data-anchor-point="' + $(this).data('link') + '"]').offset().top - (navHeight - 1)
        }, 1000);
        e.preventDefault();
      })
    }
  }
  module.exports = Fund;
})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/fund.js","/modules")